import React from "react";
import { IconProps } from "../index";
import { colors } from "src/assets";

const Index: React.FC<IconProps> = ({ color, size }) => {
  const localWidth = size * (23.74 / 24);
  const localHeight = size * (12.92 / 24);
  const localColor = color || colors.white;
  return (
    <svg viewBox="0 0 23.74 12.92" width={localWidth} height={localHeight}>
      <path
        fill={localColor}
        d="M8.47,13.06a5.88,5.88,0,0,1,.77,2.28,1.52,1.52,0,0,1-.41,1.26c-.45.48-.84,1-1.26,1.52a.39.39,0,0,1-.28.13H2.17a.36.36,0,0,1-.25-.1C1.36,17.52.81,16.87.27,16.22A.37.37,0,0,1,.17,16a9.16,9.16,0,0,1,1.89-6A11.56,11.56,0,0,1,7.82,6a11.88,11.88,0,0,1,2.89-.59,12.35,12.35,0,0,1,1.92,0,13.79,13.79,0,0,1,6.52,2.18A10.58,10.58,0,0,1,23.06,12a9.47,9.47,0,0,1,.84,3.93.48.48,0,0,1-.11.3q-.76,1-1.56,1.92a.31.31,0,0,1-.21.09c-1.74,0-3.47,0-5.21,0a.29.29,0,0,1-.2-.09c-.54-.62-1.08-1.23-1.59-1.87a1.42,1.42,0,0,1-.2-.68,4.4,4.4,0,0,1,.54-2.27c.12-.23.08-.34-.11-.5a5,5,0,0,0-3.34-1,4.89,4.89,0,0,0-2.81.75A7.4,7.4,0,0,0,8.47,13.06Zm11.37-3a10.62,10.62,0,0,0-2.08-1.57A11.51,11.51,0,0,0,4.51,9.57a7.9,7.9,0,0,0-2.82,5.8.45.45,0,0,0,.09.3c.26.33.53.64.81.94a.43.43,0,0,0,.28.13H6.5a.47.47,0,0,0,.4-.2,6.44,6.44,0,0,1,.57-.7A.74.74,0,0,0,7.66,15c-.07-.19-.11-.38-.19-.55-.21-.42-.44-.82-.66-1.23a.34.34,0,0,1,0-.35,4,4,0,0,1,1.83-1.83A7.25,7.25,0,0,1,15,10.93a4.37,4.37,0,0,1,2.05,1.73.63.63,0,0,1,0,.78,4.28,4.28,0,0,0-.7,1.77.57.57,0,0,0,.06.37c.27.36.56.7.86,1a.46.46,0,0,0,.29.11h3.68a.37.37,0,0,0,.26-.12c.23-.26.43-.55.68-.81a.68.68,0,0,0,.18-.59A8.24,8.24,0,0,0,19.84,10Z"
        transform="translate(-0.16 -5.34)"
      />
    </svg>
  );
};

export default Index;
